<div class="profile-image"
     [ngStyle]="{
      'width': configuration.size + 'px',
      'height': configuration.size + 'px',
      'border-width': configuration.borderWidth + 'px',
     }"
  [class.profile-image-hover]="configuration.menu"
  >

  @if (configuration.image) {
    <img
      [ngSrc]="configuration.image"
      [width]="configuration.size"
      [height]="configuration.size"
      class="profile-photo"
      priority="" alt="">
  }

  @if (!configuration.image && !configuration.menu) {
    <div
      class="profile-image-placeholder {{configuration.textClasses}}">
      {{ configuration.placeholder }}
    </div>
  }

  @if (!configuration.image && configuration.menu) {
    <div>
      <app-icon class="profile-image-icon" iconName="burgerMenu"></app-icon>
    </div>
  }
</div>
